export default __webpack_public_path__ + "static/media/company.93e6e03f.jpeg";